import {
  collection,
  doc,
  getDocs,
  setDoc,
  limit,
  orderBy,
  query,
  startAfter
} from "firebase/firestore";
import { auth, db } from "../firebase";

export const getUsers = async (offset, setOffset) => {
  const usersRef = query(collection(db, "users"), orderBy("createdAt"), limit(10), startAfter(offset || 0));
  const querySnapshot = await getDocs(usersRef);
  setOffset(querySnapshot.docs[querySnapshot.docs.filter((doc) => doc.data().userID !== auth?.currentUser.uid).length - 1]);
  return querySnapshot.docs.filter((doc) => doc.data().userID !== auth?.currentUser.uid).map((doc) => ({ ...doc.data(), id: doc.id }));
};

export const getAllUsers = async () => {
  const usersRef = query(collection(db, "users"));
  const querySnapshot = await getDocs(usersRef);
  return querySnapshot.docs.filter((doc) => doc.data().userID !== auth?.currentUser.uid).map((doc) => ({ ...doc.data(), id: doc.id }));
};


export const addInviteRecord = async (data) => {
  const noteRef = doc(collection(db, `users/${auth.currentUser?.uid}/invites/`));
  await setDoc(noteRef, data);
  return "success";
};
